import { statusMeta } from "@/lib/statusConfig";

export default function StatusBadge({ status, size = "sm", className = "" }) {
  const { color, label } = statusMeta(status);
  const pad = size === "lg" ? "px-3.5 py-1.5 text-xs" : "px-2.5 py-1 text-[10px]";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-mono2 uppercase tracking-wider ${pad} ${className}`}
      style={{
        color,
        backgroundColor: `${color}14`,
        border: `1px solid ${color}33`,
      }}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className="absolute inline-flex h-full w-full rounded-full pulse-ring" style={{ backgroundColor: color }} />
        <span className="relative inline-flex h-1.5 w-1.5 rounded-full" style={{ backgroundColor: color }} />
      </span>
      {label}
    </span>
  );
}
